import React, {SyntheticEvent} from 'react';
import {SelectPicker} from 'rsuite';
import {SelectPickerProps} from 'rsuite/esm/SelectPicker/SelectPicker';
import {t} from '@lingui/core/macro';
import {Control, Controller, RegisterOptions} from 'react-hook-form';
import cn from 'classnames';

import Edit from 'shared/ui/icons/General/Edit';
import {isTranslate} from 'shared/lib/lang';
import {InputStateIcon, useInputState} from 'shared/ui/Input/inputState';

import {PALETTE} from 'shared/config/model/palette';
import {brandColor} from 'shared/lib/colors';

import styles from './Select.module.scss';

interface ISelectProps extends SelectPickerProps<number|string>{
    control: Control<any>,
    name: string,
    rules?: RegisterOptions,
    // eslint-disable-next-line no-unused-vars
    onChange?: (value: string | number | null, event: SyntheticEvent<Element, Event>) => void,
    hideIcon?: boolean,
    className?: string
    validate?: boolean;
}

const Select: React.FC<ISelectProps> = ({
    cleanable,
    control,
    name,
    rules,
    onChange,
    placeholder,
    hideIcon,
    className,
    validate = true,
    defaultValue,
    ...rest
}) => {
    const {state} = useInputState({control, name, defaultValue, validate});

    const classMap = isTranslate()
        ? {
            default: styles.enSelect_default,
            filled: styles.enSelect_filled,
            valid: styles.enSelect_valid,
            error: styles.enSelect_error,
        }
        : {
            default: styles.select_default,
            filled: styles.select_active,
            valid: styles.select_valid,
            error: styles.select_error,
        };

    const baseClass = isTranslate() ? styles.enSelect : styles.select;

    return (
        <div className={cn(styles.select_container, {[styles.select_no_icon_select]: hideIcon}, className)}>
            {!hideIcon && <div className={styles.icon}>
                <InputStateIcon state={state} defaultIcon={<Edit/>} filledIcon={<Edit/>}/>
            </div>
            }
            <Controller
                control={control}
                name={name}
                rules={rules}
                defaultValue={defaultValue}
                /* eslint-disable-next-line no-unused-vars */
                render={({field: {ref, onChange: onChangeFrom, ...field}}) => (
                    <SelectPicker
                        className={cn(
                            baseClass,
                            classMap[state],
                            className,
                        )}
                        menuClassName={isTranslate() ? styles.enSelectMenu : styles.ruSelectMenu}
                        menuStyle={{
                            '--rs-listbox-option-hover-bg': brandColor(PALETTE.accentLight, PALETTE.accentLightEn),
                            '--rs-listbox-option-hover-text': brandColor(PALETTE.accent, PALETTE.accentEn),
                            '--rs-listbox-option-selected-bg': PALETTE.colorWhite,
                            '--rs-listbox-option-selected-text': brandColor(PALETTE.accent, PALETTE.accentEn),
                        } as React.CSSProperties}
                        cleanable={cleanable ?? false}
                        onChange={(value, event) => {
                            onChangeFrom(value);
                            onChange && onChange(value, event);
                        }}
                        placeholder={placeholder ?? `${t`Выберите...`}`}
                        {...rest}
                        {...field}
                    />
                )}
            />

        </div>
    );
};


export default React.memo(Select);